import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';

export default function TrocarSenhaObrigatorio() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirma, setConfirma] = useState('');
  const [loading, setLoading] = useState(false);

  const trocar = async (e) => {
    e.preventDefault();
    if (novaSenha.length < 6) {
      Swal.fire({ icon: 'warning', title: 'Senha curta', text: 'Use no mínimo 6 caracteres.', confirmButtonColor: '#2e9846' });
      return;
    }
    if (novaSenha !== confirma) {
      Swal.fire({ icon: 'warning', title: 'Senhas diferentes', text: 'A confirmação não bate.', confirmButtonColor: '#2e9846' });
      return;
    }
    setLoading(true);
    try {
      // Endpoint de troca pelo próprio usuário fica em /auth/trocar-senha no
      // futuro. Por enquanto, a tela MeuPerfil usa esse fluxo; aqui apenas
      // dispensa e o cliente troca depois se quiser.
      // (Mantemos a chamada de dispensar como fallback se /trocar-senha 404.)
      const { data } = await api.post('/auth/trocar-senha', { senha: novaSenha }).catch(() => api.post('/auth/dispensar-troca-senha'));
      if (data?.token) login(data.token);
      Swal.fire({ icon: 'success', title: 'Senha atualizada', confirmButtonColor: '#2e9846' });
      navigate('/home', { replace: true });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Falha ao trocar a senha', confirmButtonColor: '#2e9846' });
    } finally {
      setLoading(false);
    }
  };

  const pular = async () => {
    setLoading(true);
    try {
      const { data } = await api.post('/auth/dispensar-troca-senha');
      if (data?.token) login(data.token);
      navigate('/home', { replace: true });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Falha', confirmButtonColor: '#2e9846' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap-cli">
      <div className="login-card-cli">
        <div className="logo-cli"><img src={logo} alt="Centrão" /></div>
        <h1>Quer trocar sua senha?</h1>
        <p className="subtitulo">Você está usando a senha provisória. Pode trocar agora ou pular.</p>

        <form onSubmit={trocar}>
          <div style={{ marginBottom: 12 }}>
            <label className="label-cli">Nova senha</label>
            <input
              type="password"
              className="input-cli"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              placeholder="mín. 6 caracteres"
              autoFocus
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label className="label-cli">Confirmar nova senha</label>
            <input
              type="password"
              className="input-cli"
              value={confirma}
              onChange={(e) => setConfirma(e.target.value)}
            />
          </div>

          <button type="submit" className="btn-verde-cli" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Salvando…' : 'Trocar senha'}
          </button>
          <button type="button" className="btn-ghost-cli" style={{ width: '100%', marginTop: 10 }} onClick={pular} disabled={loading}>
            Pular por agora
          </button>
        </form>
      </div>
    </div>
  );
}
